import { Component, OnInit } from '@angular/core';
import { InitService } from '../services/init.service';

@Component({
  selector: 'app-gestion-proveedores',
  templateUrl: './gestion-proveedores.component.html',
  styleUrls: ['./gestion-proveedores.component.css']
})
export class GestionProveedoresComponent implements OnInit {

  constructor(private serviceInit: InitService) {
    this.serviceInit.setEstadoLayout(true);
   }

  ngOnInit(): void {
  }

}
